import React, {Component} from 'react';
import {Button} from "primereact/button";
import ContractOTCView from "./ContractOTCView";
import {ContractOTCService} from "../../service/admin/contractOTC/ContractOTCService";
import {CONTRACT_OTC_ROUTE, EDIT_CONTRACT_ROUTE} from "../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {Check, Clear} from "@material-ui/icons";

export default class ContractOTCContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables
     * se llama el servicio para consultar el contrato.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);
        this.contractOTCService = new ContractOTCService();
        this.getDataContracts = this.getDataContracts.bind(this);

        this.state = {
            dataContractOTC: this.getDataContracts(),
            contractSelected: '',
            isLoading: true,
        };

        this.handleSelectContract = this.handleSelectContract.bind(this);
        this.redirectEditContract = this.redirectEditContract.bind(this);
        this.contractOTCOrderActionTemplate = this.contractOTCOrderActionTemplate.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que construye la primer columna de la tabla de acuerdo al valor del campo otc
     * @param rowData Cada una de las líneas del DataTable.
     * @returns {*} Template de la primer columna
     */
    formatOTC(rowData) {
        let icon0 = <div><Clear color={"error"}/></div>;
        let icon1 = <div><Check color={"secondary"}/></div>;
        return (rowData['otc'] === 0 ? icon0 : icon1);
    }

    /**
     * Llena una variable del state con la información de los contratos.
     * @param {jlist} dataContracts Lista con la información de los contratos
     */
    fillDataContracts(dataContracts) {
        this.setState({
            dataContractOTC: dataContracts,
            isLoading: false,
        })
    }

    /**
     * Función que consume el ContractOTCService y obtiene la información
     * sobre los contratos.
     * @returns {Promise<void>}
     */
    getDataContracts() {
        this.loading();
        return this.contractOTCService.getBilateralAgreement()
            .then(dataContracts => this.fillDataContracts(dataContracts))
    }

    /**
     * Función que realiza el template de la última columna de la tabla, donde se
     * muestra un botón para editar el elemento.
     * @param rowData Valor del renglón
     * @param column Valor de la columna
     * @returns {html} Template del botón editar.
     */
    contractOTCOrderActionTemplate(rowData, column) {
        return (
            <Button type="button"
                    label="Editar"
                    style={{marginRight: '3em'}}
                    onClick={() => this.redirectEditContract(rowData)}/>
        );
    }

    /**
     * Función que maneja el evento del cambio en la selección del contrato a modificar.
     * @param event Evento que contiene el objeto seleccionado
     */
    handleSelectContract(event) {
        this.setState({
            contractSelected: event.value,
        });
    }

    /**
     * Función que redirecciona a la pantalla de editar el contrato seleccionado
     * Se envía el contrato y la ruta a la que tiene que que regresar.
     * @param rowData Elemento que trae la información del objeto a editar.
     */
    redirectEditContract(rowData) {
        this.props.history.push({
            pathname: EDIT_CONTRACT_ROUTE,
            state: {
                returnPath: CONTRACT_OTC_ROUTE,
                contractSelected: rowData,
            },
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataContractOTC, isLoading} = this.state;
        return (
            <ContractOTCView
                dataContractOTC={dataContractOTC}
                isLoading={isLoading}
                messagesGrowl={messagesGrowl}
                contractOTCOrderActionTemplate={this.contractOTCOrderActionTemplate}
                formatOTC={this.formatOTC}
                handleSelectContract={this.handleSelectContract}
                getDataContracts={this.getDataContracts}
            />
        );
    }
}
